import { render, staticRenderFns } from "./SettleCert.vue?vue&type=template&id=2a9a5fa1&scoped=true"
import script from "./SettleCert.vue?vue&type=script&lang=js"
export * from "./SettleCert.vue?vue&type=script&lang=js"
import style0 from "./SettleCert.vue?vue&type=style&index=0&id=2a9a5fa1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9a5fa1",
  null
  
)

export default component.exports